export const tutorials = {
    LoopCAD: [{
        section: 'Basics',
        title: 'Introduction to LoopCAD',
        duration: '7:15',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/1-Introduction/LoopCAD%20Introduction_2021.mp4',
        firstFrame: 'LoopCAD Introduction_2021_First_Frame.png',
        sortOrder: 1,
    },
    {
        section: 'Basics',
        title: 'Creating a New Project',
        duration: '9:22',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/CreateNewProject/LC_NewProject_2016.mp4',
        firstFrame: 'LC_NewProject_2016_First_Frame.png',
        sortOrder: 2,
    },

    {
        section: 'Basics',
        title: 'Drawing a Floorplan',
        duration: '12:56',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/3-Floorplans/Floorplan_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 3,
    },

    {
        section: 'Basics',
        title: 'Quick Design Mode',
        duration: '4:37',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/4-QuickDesign/Quick_Design_UP.mp4',
        firstFrame: 'Quick_Design_UP_First_Frame.png',
        sortOrder: 4,
    },

    {
        section: 'Basics',
        title: 'Manifolds and Auto-Circuits',
        duration: '9:52',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/5-ManifoldsCircuits/ManifoldsCircuits_2021.mp4',
        firstFrame: 'ManifoldsCircuits_2021_First_Frame.png',
        sortOrder: 5,
    },

    {
        section: 'Basics',
        title: 'Counterflow Circuits',
        duration: '5:13',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/Counterflow_2017_LC/Counterflow_2017_LC.mp4',
        firstFrame: 'Counterflow_2017_LC_First_Frame.png',
        sortOrder: 6,
    },

    {
        section: 'Basics',
        title: 'Freehand Circuits',
        duration: '6:38',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/5-FHCircuits/FHCircuits_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 7,
    },

    {
        section: 'Basics',
        title: 'Joist Floors',
        duration: '8:49',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/6-Joists/Joists_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 8,
    },

    {
        section: 'Basics',
        title: 'Custom Circuit Areas',
        duration: '7:02',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/CircuitAreas/CircuitAreas_LC.mp4',
        firstFrame: 'Tutorials/CircuitAreas/CircuitAreas_LC_First_Frame.png',
        sortOrder: 9,
    },

    {
        section: 'Basics',
        title: 'Review and Analysis Tools',
        duration: '8:50',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/7-Analysis/Analysis_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 10,
    },

    {
        section: 'Basics',
        title: 'Printing and Exporting',
        duration: '9:00',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/PrintingAndExporting/PrintingExporting_2016.mp4',
        firstFrame: 'PrintingExporting_2016_First_Frame.png',
        sortOrder: 11,
    },


    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Importing an AutoCAD Drawing',
        duration: '4:33',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/10-ImportingACAD/ImportACAD_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 12,
    },
    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Importing PDF and Scanned Drawings',
        duration: '3:38',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/11-ImportingPDF/ImportPDF_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 13,
    },
    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Drawing on an Imported Drawing',
        duration: '7:40',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/DrawingOnImportedDrawing/Draw-on-Import_2016.mp4',
        firstFrame: 'Draw-on-Import_2016_First_Frame.png',
        sortOrder: 14,
    },
    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Exporting to an AutoCAD File',
        duration: '1:12',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/13-ExportingACAD/ExportACAD_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 15,
    },

    {
        section: 'HVAC System Design and Calculation',
        title: 'Heating Load Calculations',
        duration: '23:00',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/HeatLoadCalculations/HeatingLoads_2016.mp4',
        firstFrame: 'HeatingLoads_2016_First_Frame.png',
        sortOrder: 16,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Cooling Load Calculations',
        duration: '14:14',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/CoolingLoadCalculations/CoolingLoads_2016.mp4',
        firstFrame: 'CoolingLoads_2016_First_Frame.png',
        sortOrder: 17,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Infiltration & Ventilation Loads',
        duration: '6:39',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/InfiltrationAndVentilationLoads/InfiltrationVentilation_2016.mp4',
        firstFrame: 'InfiltrationVentilation_2016_First_Frame.png',
        sortOrder: 18,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Entering Heat Loads Manually',
        duration: '4:39',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/ManualHeatLoads/ManualHeatLoads_2016.mp4',
        firstFrame: 'ManualHeatLoads_2016_First_Frame.png',
        sortOrder: 19,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Cold/Warm Partitions',
        duration: '3:27',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/ColdWarmPartitions/Partition_Walls_2016.mp4',
        firstFrame: 'Partition_Walls_2016_First_Frame.png',
        sortOrder: 20,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Walkout Basements',
        duration: '4:37',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/WalkoutBasement/Walkout_2016.mp4',
        firstFrame: 'Walkout_2016_First_Frame.png',
        sortOrder: 21,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Vaulted or Cathedral Ceilings',
        duration: '3:00',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/21-VaultedCathedral/VaultedCeilings_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 22,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Supply/Return Distribution Piping',
        duration: '4:37',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/SupplyReturnDistributionPiping/SR_Piping_2016.mp4',
        firstFrame: 'SR_Piping_2016_First_Frame.png',
        sortOrder: 23,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Baseboard Heating',
        duration: '4:06',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/BaseboardHeating/Baseboard_2016.mp4',
        firstFrame: 'Baseboard_2016_First_Frame.png',
        sortOrder: 24,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Wall and Ceiling Heat',
        duration: '3:22',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/CeilingWall/Wall_Ceiling_2016.mp4',
        firstFrame: 'Wall_Ceiling_2016_First_Frame.png',
        sortOrder: 25,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Adding a Water Supply Temperature',
        duration: '1:24',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/SupplyTemperature/SupplyTemperature_2016.mp4',
        firstFrame: 'SupplyTemperature_2016_First_Frame.png',
        sortOrder: 26,
    },

    {
        section: 'Snow Melt Systems',
        title: 'Creating a New Snow Melt Project',
        duration: '2:45',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/14-CreatingSnowMelt/CreateSnowMelt_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 27,
    },
    {
        section: 'Snow Melt Systems',
        title: 'Snow Melt System Design',
        duration: '3:53',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/15-SnowMeltDesign/Snowmelt_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 28,
    },
    {
        section: 'OEM Editions',
        title: 'Materials Lists & OEM Editions',
        duration: '6:15',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/29-Materials/Materials_2021.mp4',
        firstFrame: 'Materials_2021_First_Frame.png',
        sortOrder: 29,
    },
    {
        section: 'OEM Editions',
        title: 'Coil Schedule',
        duration: '3:11',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/CoilSchedule/Coil_Schedule_2016.mp4',
        firstFrame: 'Coil_Schedule_2016_First_Frame.png',
        sortOrder: 30,
    },
    {
        section: 'OEM Editions',
        title: 'Spreadsheet Design Mode - Basics',
        duration: '5:39',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/SpreadsheetDesignMode/SS_Mode_2016.mp4',
        firstFrame: 'SS_Mode_2016_First_Frame.png',
        sortOrder: 31,
    },
    {
        section: 'OEM Editions',
        title: 'Spreadsheet Design Mode - Advanced',
        duration: '10:04',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/SSModeAdvanced/SSMode_Advanced_2020.mp4',
        firstFrame: 'SSMode_Advanced_2020_First_Frame.png',
        sortOrder: 32,
    },
    {
        section: 'OEM Editions',
        title: 'Manual Quotation',
        duration: '4:31',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/ManualQuotations/Manual_Quote_2016.mp4',
        firstFrame: 'Manual_Quote_2016_First_Frame.png',
        sortOrder: 33,
    },

    {
        section: 'Additional Topics',
        title: 'Custom Editing of Circuits',
        duration: '7:41',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/16-EditingCircuit/EditCircuits_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 34,
    },
    {
        section: 'Additional Topics',
        title: 'Curved Walls and Bump Outs',
        duration: '2:50',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/18-WallEditing/WallEditing_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 35,
    },
    {
        section: 'Additional Topics',
        title: 'Custom Tables',
        duration: '4:10',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/CustomTables/Custom_Tables.mp4',
        firstFrame: 'Custom_Tables_First_Frame.png',
        sortOrder: 36,
    },
    {
        section: 'Additional Topics',
        title: 'Dimensions and Text',
        duration: '4:54',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/19-DimensionsText/DimText_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 37,
    },
    {
        section: 'Additional Topics',
        title: 'Relative Coordinates',
        duration: '1:30',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/20-RelativeCoordinates/RelativeCoord_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 38,
    },
    {
        section: 'Additional Topics',
        title: 'Multi-Floor Manifolds',
        duration: '4:22',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/MultiFloorManifolds/Multifloor_Manifolds.mp4',
        firstFrame: 'Multifloor_Manifolds_First_Frame.png',
        sortOrder: 39,
    },
    {
        section: 'Additional Topics',
        title: 'Inserting Images',
        duration: '1:55',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/40-InsertImages/Insert%20Images_2021_R1.mp4',
        firstFrame: 'Insert Images_2021_R1_First_Frame.png',
        sortOrder: 40,
        isNew: true,
    },

    {
        section: 'Additional Topics',
        title: 'Clerestory Walls and Windows',
        duration: '2:37',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/ClerestoryWalls/Clerestory_2021.mp4',
        firstFrame: 'ClerestoryWalls_LC_First_Frame.png',
        sortOrder: 41,
        isNew: true,
    },

    {
        section: 'Additional Topics',
        title: 'Rotating Drawings',
        duration: '2:37',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/RotatingDrawings/RotateDrawing_2021.mp4',
        firstFrame: 'RotateDrawings_LC_First_Frame.png',
        sortOrder: 42,
        isNew: true,
    },

    {
        section: 'Additional Topics',
        title: 'Merging Rooms',
        duration: '1:42',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/MergeRooms/MergeRooms_2021.mp4',
        firstFrame: 'MergeRooms_LC_First_Frame.png',
        sortOrder: 43,
        isNew: true,
    }],
    HeatCAD: [{
        section: 'Basics',
        title: 'Introduction to HeatCAD',
        duration: '7:14',
        path: 'https://www.avenir-online.com/AvenirWeb/HeatCAD/Tutorials/HeatCADIntroduction2016/HeatCAD Introduction_2016.mp4',
        firstFrame: 'HeatCAD_Introduction_2016_First_Frame.png',
        sortOrder: 1,
    },

    {
        section: 'Basics',
        title: 'Drawing a Floorplan',
        duration: '12:56',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/3-Floorplans/Floorplan_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 2,
    },

    {
        section: 'Basics',
        title: 'Printing and Exporting',
        duration: '9:00',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/PrintingAndExporting/PrintingExporting_2016.mp4',
        firstFrame: 'PrintingExporting_2016_First_Frame.png',
        sortOrder: 3,
    },

    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Importing an AutoCAD Drawing',
        duration: '4:33',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/10-ImportingACAD/ImportACAD_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 4,
    },

    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Importing PDF and Scanned Drawings',
        duration: '3:38',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/11-ImportingPDF/ImportPDF_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 5,
    },

    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Drawing on an Imported Drawing',
        duration: '7:40',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/DrawingOnImportedDrawing/Draw-on-Import_2016.mp4',
        firstFrame: 'Draw-on-Import_2016_First_Frame.png',
        sortOrder: 6,
    },

    {
        section: 'AutoCAD, PDF, and Scanned Files',
        title: 'Exporting to an AutoCAD File',
        duration: '1:12',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/13-ExportingACAD/ExportACAD_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 7,
    },
    {
        section: 'HVAC System Design and Calculation',
        title: 'Heating Load Calculations',
        duration: '23:00',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/HeatLoadCalculations/HeatingLoads_2016.mp4',
        firstFrame: 'HeatingLoads_2016_First_Frame.png',
        sortOrder: 8,
    },

    {
        section: 'HVAC System Design and Calculation',
        title: 'Cooling Load Calculations',
        duration: '14:14',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/CoolingLoadCalculations/CoolingLoads_2016.mp4',
        firstFrame: 'CoolingLoads_2016_First_Frame.png',
        sortOrder: 9,
    },

    {
        section: 'HVAC System Design and Calculation',
        title: 'Infiltration & Ventilation Loads',
        duration: '6:39',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/InfiltrationAndVentilationLoads/InfiltrationVentilation_2016.mp4',
        firstFrame: 'InfiltrationVentilation_2016_First_Frame.png',
        sortOrder: 10,
    },

    {
        section: 'HVAC System Design and Calculation',
        title: 'Entering Heat Loads Manually',
        duration: '4:39',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/ManualHeatLoads/ManualHeatLoads_2016.mp4',
        firstFrame: 'ManualHeatLoads_2016_First_Frame.png',
        sortOrder: 11,
    },

    {
        section: 'HVAC System Design and Calculation',
        title: 'Cold/Warm Partitions',
        duration: '3:27',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/ColdWarmPartitions/Partition_Walls_2016.mp4',
        firstFrame: 'Partition_Walls_2016_First_Frame.png',
        sortOrder: 12,
    },

    {
        section: 'HVAC System Design and Calculation',
        title: 'Walkout Basements',
        duration: '4:37',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/WalkoutBasement/Walkout_2016.mp4',
        firstFrame: 'Walkout_2016_First_Frame.png',
        sortOrder: 13,
    },

    {
        section: 'HVAC System Design and Calculation',
        title: 'Vaulted or Cathedral Ceilings',
        duration: '3:00',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/21-VaultedCathedral/VaultedCeilings_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 14,
    },

    {
        section: 'HVAC System Design and Calculation',
        title: 'Baseboard Heating',
        duration: '4:06',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/BaseboardHeating/Baseboard_2016.mp4',
        firstFrame: 'Baseboard_2016_First_Frame.png',
        sortOrder: 15,
    },

    {
        section: 'HVAC System Design and Calculation',
        title: 'Wall and Ceiling Heat',
        duration: '3:22',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/CeilingWall/Wall_Ceiling_2016.mp4',
        firstFrame: 'Wall_Ceiling_2016_First_Frame.png',
        sortOrder: 16,
    },
    {
        section: 'Additional Topics',
        title: 'Curved Walls and Bump Outs',
        duration: '2:50',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/18-WallEditing/WallEditing_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 17,
    },

    {
        section: 'Additional Topics',
        title: 'Custom Tables',
        duration: '4:10',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/CustomTables/Custom_Tables.mp4',
        firstFrame: 'Custom_Tables_First_Frame.png',
        sortOrder: 18,
    },

    {
        section: 'Additional Topics',
        title: 'Dimensions and Text',
        duration: '4:54',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/19-DimensionsText/DimText_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 19,
    },

    {
        section: 'Additional Topics',
        title: 'Relative Coordinates',
        duration: '1:30',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/20-RelativeCoordinates/RelativeCoord_LC2.mp4',
        firstFrame: 'FirstFrame.png',
        sortOrder: 20,
    },

    {
        section: 'Additional Topics',
        title: 'Inserting Images',
        duration: '1:54',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/InsertImages/InsertImages_2021.mp4',
        firstFrame: 'InsertImages_LC_First_Frame.png',
        isNew: true,
        sortOrder: 21,
    },

    {
        section: 'Additional Topics',
        title: 'Clerestory Walls and Windows',
        duration: '2:37',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/ClerestoryWalls/Clerestory_2021.mp4',
        firstFrame: 'ClerestoryWalls_LC_First_Frame.png',
        isNew: true,
        sortOrder: 22,
    },

    {
        section: 'Additional Topics',
        title: 'Rotating Drawings',
        duration: '2:37',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/RotatingDrawings/RotateDrawing_2021.mp4',
        firstFrame: 'RotateDrawings_LC_First_Frame.png',
        isNew: true,
        sortOrder: 23,
    },

    {
        section: 'Additional Topics',
        title: 'Merging Rooms',
        duration: '1:42',
        path: 'https://www.avenir-online.com/AvenirWeb/LoopCAD/Tutorials/MergeRooms/MergeRooms_2021.mp4',
        firstFrame: 'MergeRooms_LC_First_Frame.png',
        isNew: true,
        sortOrder: 24,
    }],
    PlumbingCAD: [{
        section: 'Basics',
        title: 'Introduction to PlumbingCAD',
        duration: '8:20',
        path: 'https://www.avenir-online.com/AvenirWeb/PlumbingCAD/Tutorials/Introduction/PlumbingCAD Introduction_2018.mp4',
        firstFrame: 'Intro2018_PC.png',
        sortOrder: 1,
    },

    {
        section: 'Basics',
        title: 'Importing a PDF Drawing',
        duration: '4:34',
        path: 'https://www.avenir-online.com/AvenirWeb/PlumbingCAD/Tutorials/PDFImport/PCAD Importing PDF_2018.mp4',
        firstFrame: 'Intro2018_PC.png',
        sortOrder: 2,
    },

    {
        section: 'Basics',
        title: 'Importing an AutoCAD Drawing',
        duration: '4:25',
        path: 'https://www.avenir-online.com/AvenirWeb/PlumbingCAD/Tutorials/ImportDWG/PCAD Importing DWG_2018.mp4',
        firstFrame: 'Intro2018_PC.png',
        sortOrder: 3,
    },

    {
        section: 'Basics',
        title: 'Defining the Plumbing System',
        duration: '12:30',
        path: 'https://www.avenir-online.com/AvenirWeb/PlumbingCAD/Tutorials/DefiningPlumbing/PCAD Defining Plumbing_2018.mp4',
        firstFrame: 'Intro2018_PC.png',
        sortOrder: 4,
    },

    {
        section: 'Basics',
        title: 'Materials Lists and Quotations',
        duration: '5:50',
        path: 'https://www.avenir-online.com/AvenirWeb/PlumbingCAD/Tutorials/MatListsAndQuotations/PCAD MaterialsLists_2018.mp4',
        firstFrame: 'Intro2018_PC.png',
        sortOrder: 5,
    }]

}

